export default "__VITE_ASSET__10cb2cb3__"